import { checkerCompanionName } from "../utilities/checker"
import { initialsOf } from "../utilities/watchlist"

/**
 * "Companions: N of M accepted", with an overlapping stack of avatars for
 * the accepted subset (photo, else initials) -- the right-hand half of a
 * Checker trip card's stats row. Mirrors the Android app's ActiveTripCard.
 *
 * @param {Object[]} acceptedCompanions - Already filtered to status "accepted"
 * @param {number} totalCount - Everyone still invited (accepted + pending)
 * @param {number} [max] - Avatars shown before the rest are just counted
 */
export default function CheckerCompanionAvatars({
    acceptedCompanions,
    totalCount,
    max = 5,
}) {
    return (
        <div className="checker-companions">
            <div className="checker-companions-count">
                Companions: {acceptedCompanions.length} of {totalCount}
            </div>
            {acceptedCompanions.length === 0 ? (
                // Keeps this column the same two-line height as "Next
                // check-in"/"Cadence" beside it.
                <div className="checker-companions-placeholder">---</div>
            ) : (
                <div className="checker-companions-stack">
                    {acceptedCompanions.slice(0, max).map((companion) => {
                        const name = checkerCompanionName(companion)
                        return (
                            <span
                                className="checker-companion-avatar"
                                key={companion.user_id}
                                title={name}
                            >
                                {companion.profile_picture_url ? (
                                    <img src={companion.profile_picture_url} alt={name} />
                                ) : (
                                    <span>{initialsOf(name)}</span>
                                )}
                            </span>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
